import { getIn } from 'formik';

export const getTouchedError = (
  errors: unknown,
  touched: unknown,
  name: string,
): string | undefined =>
  getIn(touched, name)
    ? (getIn(errors, name) as string | undefined)
    : undefined;
